import React, { CSSProperties } from "react";
import { Stack, SvgIconProps, useTheme } from "@mui/material";
import { renderToString } from "react-dom/server";
import { ReactComponent as ArrowTriangleIcon } from "../../assets/svg/triangle-up.svg";
import { ReactComponent as blueDefault } from "../../assets/svg/blue.svg";
import { ReactComponent as pinkDefault } from "../../assets/svg/pinkPink.svg";
import { ReactComponent as lightBlueDefault } from "../../assets/svg/lightBlue.svg";
import { ReactComponent as primaryDefault } from "../../assets/svg/primary.svg";
import { ReactComponent as greenDefault } from "../../assets/svg/greern.svg";
import { ReactComponent as CaretSort } from "../../assets/svg/caret-sort.svg";
import { ReactComponent as BTC } from "../../assets/svg/BTC.svg";
import { ReactComponent as BTC_LIGHT } from "../../assets/svg/BTC_LIGHT.svg";
import { ReactComponent as USDT } from "../../assets/svg/USDT.svg";
import { ReactComponent as USDT_LIGHT } from "../../assets/svg/USDT_LIGHT.svg";
import { ReactComponent as EOS } from "../../assets/svg/EOS.svg";
import { ReactComponent as XMR } from "../../assets/svg/xmr.svg";
import { ReactComponent as BCH } from "../../assets/svg/BCH.svg";
import { ReactComponent as ETH } from "../../assets/svg/ETH.svg";
import { ReactComponent as XRP } from "../../assets/svg/XRP.svg";
import { ReactComponent as LTC } from "../../assets/svg/LTC.svg";
import { ReactComponent as EUR } from "../../assets/svg/EUR.svg";
import { ReactComponent as BINANCE } from "../../assets/svg/BINANCE.svg";
import { ReactComponent as OKX } from "../../assets/svg/okx.svg";
import { ReactComponent as AEVO } from "../../assets/svg/aevo.svg";
import { ReactComponent as REYA } from "../../assets/svg/reya.svg";
import { ReactComponent as BYBIT } from "../../assets/svg/bybit.svg";
import { ReactComponent as chevronDown } from "../../assets/svg/chevron-down.svg";
import { ReactComponent as Auto } from "../../assets/svg/auto.svg";
import { ReactComponent as SuccessIcon } from "../../assets/svg/party-popper.svg";
import { ReactComponent as ErrorIcon } from "../../assets/svg/error-triangle.svg";
import { ReactComponent as AlertIcon } from "../../assets/svg/alert-triangle.svg";
import { ReactComponent as InfoIcon } from "../../assets/svg/info-circled.svg";
import { ReactComponent as ChevronRight } from "../../assets/svg/chevron-right.svg";
import { ReactComponent as Plus } from "../../assets/svg/plus.svg";
import { ReactComponent as Clock } from "../../assets/svg/clock-9.svg";
import { ReactComponent as Coins } from "../../assets/svg/coins.svg";
import { ReactComponent as Russia } from "../../assets/svg/russia.svg";
import { ReactComponent as UK } from "../../assets/svg/united_kingdom.svg";
import { ReactComponent as Copy } from "../../assets/svg/copy.svg";
import { ReactComponent as TradeDown } from "../../assets/svg/hugeicons_trade-down.svg";
import { ReactComponent as TradeUp } from "../../assets/svg/hugeicons_trade-up.svg";
import { ReactComponent as TradeCenter } from "../../assets/svg/trade-central.svg";
import { ReactComponent as ChevronLeft } from "../../assets/svg/chevron-left.svg";
import { ReactComponent as DotFilled } from "../../assets/svg/dot-filled.svg";
import { ReactComponent as USDT_COLOR } from "../../assets/svg/usdt_colors.svg";
import { ReactComponent as CHECK_CIRCLED } from "../../assets/svg/check-circled.svg";
import { ReactComponent as Settings } from "../../assets/svg/settings.svg";
import { ReactComponent as Check } from "../../assets/svg/check.svg";
import { ReactComponent as USDC } from "../../assets/svg/usdc.svg";
import { ReactComponent as OutCheck } from "../../assets/svg/Checkbox.svg";
import { ReactComponent as CheckedIcon } from "../../assets/svg/checkbox-checked.svg";
import { ReactComponent as Avatar } from "../../assets/svg/avatar.svg";
import { ReactComponent as ErrorTriangle } from "../../assets/svg/errorsave.svg";
import { ReactComponent as HPOS10I } from "../../assets/svg/XTVCBITCOIN--big.svg";
import { ReactComponent as BELL } from "../../assets/svg/bell.svg";
import { ReactComponent as TRUMP } from "../../assets/svg/TRUMP.svg";
import { ReactComponent as MinusQuare } from "../../assets/svg/minus-square.svg";
import { ReactComponent as PlusQuare } from "../../assets/svg/plus-square.svg";
import { ReactComponent as Search } from "../../assets/svg/search.svg";
import { ReactComponent as RadioChecked } from "../../assets/svg/RadioChecked.svg";
import { ReactComponent as RadioUnchecked } from "../../assets/svg/RadioUnchecked.svg";

// import { ReactComponent as $PAC } from '../../assets/svg/crypto/$pac.svg';
// import { ReactComponent as XBTC } from '../../assets/svg/crypto/0xbtc.svg';
// import { ReactComponent as INCH } from '../../assets/svg/crypto/1inch.svg';
// import { ReactComponent as GIVE } from '../../assets/svg/crypto/2give.svg';

import { ReactComponent as AAVE } from "../../assets/svg/crypto/aave.svg";
import { ReactComponent as ABT } from "../../assets/svg/crypto/abt.svg";
import { ReactComponent as ACT } from "../../assets/svg/crypto/act.svg";
import { ReactComponent as ACTN } from "../../assets/svg/crypto/actn.svg";
import { ReactComponent as ADA } from "../../assets/svg/crypto/ada.svg";
import { ReactComponent as ADD } from "../../assets/svg/crypto/add.svg";
import { ReactComponent as ADX } from "../../assets/svg/crypto/adx.svg";
import { ReactComponent as AE } from "../../assets/svg/crypto/ae.svg";
import { ReactComponent as AEON } from "../../assets/svg/crypto/aeon.svg";
import { ReactComponent as AEUR } from "../../assets/svg/crypto/aeur.svg";
import { ReactComponent as AGI } from "../../assets/svg/crypto/agi.svg";
import { ReactComponent as AGRS } from "../../assets/svg/crypto/agrs.svg";
import { ReactComponent as AION } from "../../assets/svg/crypto/aion.svg";
import { ReactComponent as ALGO } from "../../assets/svg/crypto/algo.svg";
import { ReactComponent as AMB } from "../../assets/svg/crypto/amb.svg";
import { ReactComponent as AMP } from "../../assets/svg/crypto/amp.svg";
import { ReactComponent as AMPL } from "../../assets/svg/crypto/ampl.svg";
import { ReactComponent as ANKR } from "../../assets/svg/crypto/ankr.svg";
import { ReactComponent as ANT } from "../../assets/svg/crypto/ant.svg";
import { ReactComponent as APE } from "../../assets/svg/crypto/ape.svg";
import { ReactComponent as APEX } from "../../assets/svg/crypto/apex.svg";
import { ReactComponent as APPC } from "../../assets/svg/crypto/appc.svg";
import { ReactComponent as ARDR } from "../../assets/svg/crypto/ardr.svg";
import { ReactComponent as ARG } from "../../assets/svg/crypto/arg.svg";
import { ReactComponent as ARK } from "../../assets/svg/crypto/ark.svg";
import { ReactComponent as ARN } from "../../assets/svg/crypto/arn.svg";
import { ReactComponent as ARNX } from "../../assets/svg/crypto/arnx.svg";
import { ReactComponent as ARY } from "../../assets/svg/crypto/ary.svg";
import { ReactComponent as AST } from "../../assets/svg/crypto/ast.svg";
import { ReactComponent as ATLAS } from "../../assets/svg/crypto/atlas.svg";
import { ReactComponent as ATM } from "../../assets/svg/crypto/atm.svg";
import { ReactComponent as ATOM } from "../../assets/svg/crypto/atom.svg";
import { ReactComponent as AUDR } from "../../assets/svg/crypto/audr.svg";
import { ReactComponent as AURY } from "../../assets/svg/crypto/aury.svg";
import { ReactComponent as AUTO } from "../../assets/svg/crypto/auto.svg";
import { ReactComponent as AVAX } from "../../assets/svg/crypto/avax.svg";
import { ReactComponent as AYWA } from "../../assets/svg/crypto/aywa.svg";
import { ReactComponent as BAB } from "../../assets/svg/crypto/bab.svg";
import { ReactComponent as BAL } from "../../assets/svg/crypto/bal.svg";
import { ReactComponent as BAND } from "../../assets/svg/crypto/band.svg";
import { ReactComponent as BAT } from "../../assets/svg/crypto/bat.svg";
import { ReactComponent as BAY } from "../../assets/svg/crypto/bay.svg";
import { ReactComponent as BCBC } from "../../assets/svg/crypto/bcbc.svg";
import { ReactComponent as BCC } from "../../assets/svg/crypto/bcc.svg";
import { ReactComponent as BCD } from "../../assets/svg/crypto/bcd.svg";
import { ReactComponent as BCIO } from "../../assets/svg/crypto/bcio.svg";
import { ReactComponent as BCN } from "../../assets/svg/crypto/bcn.svg";
import { ReactComponent as BCO } from "../../assets/svg/crypto/bco.svg";
import { ReactComponent as BCPT } from "../../assets/svg/crypto/bcpt.svg";
import { ReactComponent as BDL } from "../../assets/svg/crypto/bdl.svg";
import { ReactComponent as BEAM } from "../../assets/svg/crypto/beam.svg";
import { ReactComponent as BELA } from "../../assets/svg/crypto/bela.svg";
import { ReactComponent as BIX } from "../../assets/svg/crypto/bix.svg";
import { ReactComponent as BLCN } from "../../assets/svg/crypto/blcn.svg";
import { ReactComponent as BLK } from "../../assets/svg/crypto/blk.svg";
import { ReactComponent as BLOCK } from "../../assets/svg/crypto/block.svg";
import { ReactComponent as BLZ } from "../../assets/svg/crypto/blz.svg";
import { ReactComponent as BNB } from "../../assets/svg/crypto/bnb.svg";
import { ReactComponent as BNT } from "../../assets/svg/crypto/bnt.svg";
import { ReactComponent as BNTY } from "../../assets/svg/crypto/bnty.svg";
import { ReactComponent as BOOTY } from "../../assets/svg/crypto/booty.svg";
import { ReactComponent as BOS } from "../../assets/svg/crypto/bos.svg";
import { ReactComponent as BPT } from "../../assets/svg/crypto/bpt.svg";
import { ReactComponent as BQ } from "../../assets/svg/crypto/bq.svg";
import { ReactComponent as BRD } from "../../assets/svg/crypto/brd.svg";
import { ReactComponent as BSD } from "../../assets/svg/crypto/bsd.svg";
import { ReactComponent as BSV } from "../../assets/svg/crypto/bsv.svg";
import { ReactComponent as BTCD } from "../../assets/svg/crypto/btcd.svg";
import { ReactComponent as BTCH } from "../../assets/svg/crypto/btch.svg";
import { ReactComponent as BTCP } from "../../assets/svg/crypto/btcp.svg";
import { ReactComponent as BTCZ } from "../../assets/svg/crypto/btcz.svg";
import { ReactComponent as BTDX } from "../../assets/svg/crypto/btdx.svg";
import { ReactComponent as BTG } from "../../assets/svg/crypto/btg.svg";
import { ReactComponent as BTM } from "../../assets/svg/crypto/btm.svg";
import { ReactComponent as BTS } from "../../assets/svg/crypto/bts.svg";
import { ReactComponent as BTT } from "../../assets/svg/crypto/btt.svg";
import { ReactComponent as BTX } from "../../assets/svg/crypto/btx.svg";
import { ReactComponent as BURST } from "../../assets/svg/crypto/burst.svg";
import { ReactComponent as BZE } from "../../assets/svg/crypto/bze.svg";
import { ReactComponent as CALL } from "../../assets/svg/crypto/call.svg";
import { ReactComponent as CC } from "../../assets/svg/crypto/cc.svg";
import { ReactComponent as CDN } from "../../assets/svg/crypto/cdn.svg";
import { ReactComponent as CDT } from "../../assets/svg/crypto/cdt.svg";
import { ReactComponent as CENZ } from "../../assets/svg/crypto/cenz.svg";
import { ReactComponent as CHAIN } from "../../assets/svg/crypto/chain.svg";
import { ReactComponent as CHAT } from "../../assets/svg/crypto/chat.svg";
import { ReactComponent as CHIPS } from "../../assets/svg/crypto/chips.svg";
import { ReactComponent as CHSB } from "../../assets/svg/crypto/chsb.svg";
import { ReactComponent as CHZ } from "../../assets/svg/crypto/chz.svg";
import { ReactComponent as CIX } from "../../assets/svg/crypto/cix.svg";
import { ReactComponent as CLAM } from "../../assets/svg/crypto/clam.svg";
import { ReactComponent as CLOAK } from "../../assets/svg/crypto/cloak.svg";
import { ReactComponent as CMM } from "../../assets/svg/crypto/cmm.svg";
import { ReactComponent as CMT } from "../../assets/svg/crypto/cmt.svg";
import { ReactComponent as CND } from "../../assets/svg/crypto/cnd.svg";
import { ReactComponent as CNX } from "../../assets/svg/crypto/cnx.svg";
import { ReactComponent as CNY } from "../../assets/svg/crypto/cny.svg";
import { ReactComponent as COB } from "../../assets/svg/crypto/cob.svg";
import { ReactComponent as COLX } from "../../assets/svg/crypto/colx.svg";
import { ReactComponent as COMP } from "../../assets/svg/crypto/comp.svg";
import { ReactComponent as COQUI } from "../../assets/svg/crypto/coqui.svg";
import { ReactComponent as CRED } from "../../assets/svg/crypto/cred.svg";
import { ReactComponent as CRPT } from "../../assets/svg/crypto/crpt.svg";
import { ReactComponent as CRV } from "../../assets/svg/crypto/crv.svg";
import { ReactComponent as CRW } from "../../assets/svg/crypto/crw.svg";
import { ReactComponent as CS } from "../../assets/svg/crypto/cs.svg";
import { ReactComponent as CTR } from "../../assets/svg/crypto/ctr.svg";
import { ReactComponent as CTXC } from "../../assets/svg/crypto/ctxc.svg";
import { ReactComponent as CVC } from "../../assets/svg/crypto/cvc.svg";
import { ReactComponent as D } from "../../assets/svg/crypto/d.svg";
import { ReactComponent as DAI } from "../../assets/svg/crypto/dai.svg";
import { ReactComponent as DASH } from "../../assets/svg/crypto/dash.svg";
import { ReactComponent as DAT } from "../../assets/svg/crypto/dat.svg";
import { ReactComponent as DATA } from "../../assets/svg/crypto/data.svg";
import { ReactComponent as DBC } from "../../assets/svg/crypto/dbc.svg";
import { ReactComponent as DCN } from "../../assets/svg/crypto/dcn.svg";
import { ReactComponent as DCR } from "../../assets/svg/crypto/dcr.svg";
import { ReactComponent as DEEZ } from "../../assets/svg/crypto/deez.svg";
import { ReactComponent as DENT } from "../../assets/svg/crypto/dent.svg";
import { ReactComponent as DEW } from "../../assets/svg/crypto/dew.svg";
import { ReactComponent as DGB } from "../../assets/svg/crypto/dgb.svg";
import { ReactComponent as DGD } from "../../assets/svg/crypto/dgd.svg";
import { ReactComponent as DLT } from "../../assets/svg/crypto/dlt.svg";
import { ReactComponent as DNT } from "../../assets/svg/crypto/dnt.svg";
import { ReactComponent as DOCK } from "../../assets/svg/crypto/dock.svg";
import { ReactComponent as DOGE } from "../../assets/svg/crypto/doge.svg";
import { ReactComponent as DOT } from "../../assets/svg/crypto/dot.svg";
import { ReactComponent as DRGN } from "../../assets/svg/crypto/drgn.svg";
import { ReactComponent as DROP } from "../../assets/svg/crypto/drop.svg";
import { ReactComponent as DTA } from "../../assets/svg/crypto/dta.svg";
import { ReactComponent as DTH } from "../../assets/svg/crypto/dth.svg";
import { ReactComponent as DTR } from "../../assets/svg/crypto/dtr.svg";
import { ReactComponent as EBST } from "../../assets/svg/crypto/ebst.svg";
import { ReactComponent as ECA } from "../../assets/svg/crypto/eca.svg";
import { ReactComponent as EDG } from "../../assets/svg/crypto/edg.svg";
import { ReactComponent as EDO } from "../../assets/svg/crypto/edo.svg";
import { ReactComponent as EDOGE } from "../../assets/svg/crypto/edoge.svg";
import { ReactComponent as ELA } from "../../assets/svg/crypto/ela.svg";
import { ReactComponent as ELEC } from "../../assets/svg/crypto/elec.svg";
import { ReactComponent as ELF } from "../../assets/svg/crypto/elf.svg";
import { ReactComponent as ELIX } from "../../assets/svg/crypto/elix.svg";
import { ReactComponent as ELLA } from "../../assets/svg/crypto/ella.svg";
import { ReactComponent as EMB } from "../../assets/svg/crypto/emb.svg";
import { ReactComponent as EMC } from "../../assets/svg/crypto/emc.svg";
import { ReactComponent as EMC2 } from "../../assets/svg/crypto/emc2.svg";
import { ReactComponent as ENG } from "../../assets/svg/crypto/eng.svg";
import { ReactComponent as ENJ } from "../../assets/svg/crypto/enj.svg";
import { ReactComponent as ENTRP } from "../../assets/svg/crypto/entrp.svg";
import { ReactComponent as EON } from "../../assets/svg/crypto/eon.svg";
import { ReactComponent as EOP } from "../../assets/svg/crypto/eop.svg";
import { ReactComponent as EQLI } from "../../assets/svg/crypto/eqli.svg";
import { ReactComponent as EQUA } from "../../assets/svg/crypto/equa.svg";
import { ReactComponent as ETC } from "../../assets/svg/crypto/etc.svg";
import { ReactComponent as ETHOS } from "../../assets/svg/crypto/ethos.svg";
import { ReactComponent as ETN } from "../../assets/svg/crypto/etn.svg";
import { ReactComponent as ETP } from "../../assets/svg/crypto/etp.svg";
import { ReactComponent as EVX } from "../../assets/svg/crypto/evx.svg";
import { ReactComponent as EXMO } from "../../assets/svg/crypto/exmo.svg";
import { ReactComponent as EXP } from "../../assets/svg/crypto/exp.svg";
import { ReactComponent as FAIR } from "../../assets/svg/crypto/fair.svg";
import { ReactComponent as FCT } from "../../assets/svg/crypto/fct.svg";
import { ReactComponent as FIDA } from "../../assets/svg/crypto/fida.svg";
import { ReactComponent as FIL } from "../../assets/svg/crypto/fil.svg";
import { ReactComponent as FJC } from "../../assets/svg/crypto/fjc.svg";
import { ReactComponent as FLDC } from "../../assets/svg/crypto/fldc.svg";
import { ReactComponent as FLO } from "../../assets/svg/crypto/flo.svg";
import { ReactComponent as FLUX } from "../../assets/svg/crypto/flux.svg";
import { ReactComponent as FSN } from "../../assets/svg/crypto/fsn.svg";
import { ReactComponent as FTC } from "../../assets/svg/crypto/ftc.svg";
import { ReactComponent as FUEL } from "../../assets/svg/crypto/fuel.svg";
import { ReactComponent as FUN } from "../../assets/svg/crypto/fun.svg";
import { ReactComponent as GAME } from "../../assets/svg/crypto/game.svg";
import { ReactComponent as GAS } from "../../assets/svg/crypto/gas.svg";
import { ReactComponent as GBP } from "../../assets/svg/crypto/gbp.svg";
import { ReactComponent as GBX } from "../../assets/svg/crypto/gbx.svg";
import { ReactComponent as GBYTE } from "../../assets/svg/crypto/gbyte.svg";
import { ReactComponent as GENERIC } from "../../assets/svg/crypto/generic.svg";
import { ReactComponent as GIN } from "../../assets/svg/crypto/gin.svg";
import { ReactComponent as GLXT } from "../../assets/svg/crypto/glxt.svg";
import { ReactComponent as GMR } from "../../assets/svg/crypto/gmr.svg";
import { ReactComponent as GMT } from "../../assets/svg/crypto/gmt.svg";
import { ReactComponent as GNO } from "../../assets/svg/crypto/gno.svg";
import { ReactComponent as GNT } from "../../assets/svg/crypto/gnt.svg";
import { ReactComponent as GOLD } from "../../assets/svg/crypto/gold.svg";
import { ReactComponent as GRC } from "../../assets/svg/crypto/grc.svg";
import { ReactComponent as GRIN } from "../../assets/svg/crypto/grin.svg";
import { ReactComponent as GRS } from "../../assets/svg/crypto/grs.svg";
import { ReactComponent as GRT } from "../../assets/svg/crypto/grt.svg";
import { ReactComponent as GSC } from "../../assets/svg/crypto/gsc.svg";
import { ReactComponent as GTO } from "../../assets/svg/crypto/gto.svg";
import { ReactComponent as GUP } from "../../assets/svg/crypto/gup.svg";
import { ReactComponent as GUSD } from "../../assets/svg/crypto/gusd.svg";
import { ReactComponent as GVT } from "../../assets/svg/crypto/gvt.svg";
import { ReactComponent as GXS } from "../../assets/svg/crypto/gxs.svg";
import { ReactComponent as GZR } from "../../assets/svg/crypto/gzr.svg";
import { ReactComponent as HIGHT } from "../../assets/svg/crypto/hight.svg";
import { ReactComponent as HNS } from "../../assets/svg/crypto/hns.svg";
import { ReactComponent as HODL } from "../../assets/svg/crypto/hodl.svg";
import { ReactComponent as HOT } from "../../assets/svg/crypto/hot.svg";
import { ReactComponent as HPB } from "../../assets/svg/crypto/hpb.svg";
import { ReactComponent as HSR } from "../../assets/svg/crypto/hsr.svg";
import { ReactComponent as HT } from "../../assets/svg/crypto/ht.svg";
import { ReactComponent as HTML } from "../../assets/svg/crypto/html.svg";
import { ReactComponent as HUC } from "../../assets/svg/crypto/huc.svg";
import { ReactComponent as HUSD } from "../../assets/svg/crypto/husd.svg";
import { ReactComponent as HUSH } from "../../assets/svg/crypto/hush.svg";
import { ReactComponent as ICN } from "../../assets/svg/crypto/icn.svg";
import { ReactComponent as ICP } from "../../assets/svg/crypto/icp.svg";
import { ReactComponent as ICX } from "../../assets/svg/crypto/icx.svg";
import { ReactComponent as IGNIS } from "../../assets/svg/crypto/ignis.svg";
import { ReactComponent as ILK } from "../../assets/svg/crypto/ilk.svg";
import { ReactComponent as INK } from "../../assets/svg/crypto/ink.svg";
import { ReactComponent as INS } from "../../assets/svg/crypto/ins.svg";
import { ReactComponent as ION } from "../../assets/svg/crypto/ion.svg";
import { ReactComponent as IOP } from "../../assets/svg/crypto/iop.svg";
import { ReactComponent as IOST } from "../../assets/svg/crypto/iost.svg";
import { ReactComponent as IOTX } from "../../assets/svg/crypto/iotx.svg";
import { ReactComponent as IQ } from "../../assets/svg/crypto/iq.svg";
import { ReactComponent as ITC } from "../../assets/svg/crypto/itc.svg";
import { ReactComponent as JNT } from "../../assets/svg/crypto/jnt.svg";
import { ReactComponent as JPY } from "../../assets/svg/crypto/jpy.svg";
import { ReactComponent as KCS } from "../../assets/svg/crypto/kcs.svg";
import { ReactComponent as KIN } from "../../assets/svg/crypto/kin.svg";
import { ReactComponent as KLOWN } from "../../assets/svg/crypto/klown.svg";
import { ReactComponent as KMD } from "../../assets/svg/crypto/kmd.svg";
import { ReactComponent as KNC } from "../../assets/svg/crypto/knc.svg";
import { ReactComponent as KRB } from "../../assets/svg/crypto/krb.svg";
import { ReactComponent as KSM } from "../../assets/svg/crypto/ksm.svg";
import { ReactComponent as LBC } from "../../assets/svg/crypto/lbc.svg";
import { ReactComponent as LEND } from "../../assets/svg/crypto/lend.svg";
import { ReactComponent as LEO } from "../../assets/svg/crypto/leo.svg";
import { ReactComponent as LINK } from "../../assets/svg/crypto/link.svg";
import { ReactComponent as LKK } from "../../assets/svg/crypto/lkk.svg";
import { ReactComponent as LOOM } from "../../assets/svg/crypto/loom.svg";
import { ReactComponent as LPT } from "../../assets/svg/crypto/lpt.svg";
import { ReactComponent as LRC } from "../../assets/svg/crypto/lrc.svg";
import { ReactComponent as LSK } from "../../assets/svg/crypto/lsk.svg";
import { ReactComponent as LUN } from "../../assets/svg/crypto/lun.svg";
import { ReactComponent as MAID } from "../../assets/svg/crypto/maid.svg";
import { ReactComponent as MANA } from "../../assets/svg/crypto/mana.svg";
import { ReactComponent as MATIC } from "../../assets/svg/crypto/matic.svg";
import { ReactComponent as MAX } from "../../assets/svg/crypto/max.svg";
import { ReactComponent as MCAP } from "../../assets/svg/crypto/mcap.svg";
import { ReactComponent as MCO } from "../../assets/svg/crypto/mco.svg";
import { ReactComponent as MDA } from "../../assets/svg/crypto/mda.svg";
import { ReactComponent as MDS } from "../../assets/svg/crypto/mds.svg";
import { ReactComponent as MED } from "../../assets/svg/crypto/med.svg";
import { ReactComponent as MEETONE } from "../../assets/svg/crypto/meetone.svg";
import { ReactComponent as MFT } from "../../assets/svg/crypto/mft.svg";
import { ReactComponent as MIOTA } from "../../assets/svg/crypto/miota.svg";
import { ReactComponent as MITH } from "../../assets/svg/crypto/mith.svg";
import { ReactComponent as MKR } from "../../assets/svg/crypto/mkr.svg";
import { ReactComponent as MLN } from "../../assets/svg/crypto/mln.svg";
import { ReactComponent as MNX } from "../../assets/svg/crypto/mnx.svg";
import { ReactComponent as MNZ } from "../../assets/svg/crypto/mnz.svg";
import { ReactComponent as MOAC } from "../../assets/svg/crypto/moac.svg";
import { ReactComponent as MOD } from "../../assets/svg/crypto/mod.svg";
import { ReactComponent as MONA } from "../../assets/svg/crypto/mona.svg";
import { ReactComponent as MSR } from "../../assets/svg/crypto/msr.svg";
import { ReactComponent as MTH } from "../../assets/svg/crypto/mth.svg";
import { ReactComponent as MTL } from "../../assets/svg/crypto/mtl.svg";
import { ReactComponent as MUSIC } from "../../assets/svg/crypto/music.svg";
import { ReactComponent as MZC } from "../../assets/svg/crypto/mzc.svg";
import { ReactComponent as NANO } from "../../assets/svg/crypto/nano.svg";
import { ReactComponent as NAS } from "../../assets/svg/crypto/nas.svg";
import { ReactComponent as NAV } from "../../assets/svg/crypto/nav.svg";
import { ReactComponent as NCASH } from "../../assets/svg/crypto/ncash.svg";
import { ReactComponent as NDZ } from "../../assets/svg/crypto/ndz.svg";
import { ReactComponent as NEBL } from "../../assets/svg/crypto/nebl.svg";
import { ReactComponent as NEO } from "../../assets/svg/crypto/neo.svg";
import { ReactComponent as NEOS } from "../../assets/svg/crypto/neos.svg";
import { ReactComponent as NEU } from "../../assets/svg/crypto/neu.svg";
import { ReactComponent as NEXO } from "../../assets/svg/crypto/nexo.svg";
import { ReactComponent as NGC } from "../../assets/svg/crypto/ngc.svg";
import { ReactComponent as NIO } from "../../assets/svg/crypto/nio.svg";
import { ReactComponent as NKN } from "../../assets/svg/crypto/nkn.svg";
import { ReactComponent as NLC2 } from "../../assets/svg/crypto/nlc2.svg";
import { ReactComponent as NLG } from "../../assets/svg/crypto/nlg.svg";
import { ReactComponent as NMC } from "../../assets/svg/crypto/nmc.svg";
import { ReactComponent as NMR } from "../../assets/svg/crypto/nmr.svg";
import { ReactComponent as NPXS } from "../../assets/svg/crypto/npxs.svg";
import { ReactComponent as NTBC } from "../../assets/svg/crypto/ntbc.svg";
import { ReactComponent as NULS } from "../../assets/svg/crypto/nuls.svg";
import { ReactComponent as NXS } from "../../assets/svg/crypto/nxs.svg";
import { ReactComponent as NXT } from "../../assets/svg/crypto/nxt.svg";
import { ReactComponent as OAX } from "../../assets/svg/crypto/oax.svg";
import { ReactComponent as OK } from "../../assets/svg/crypto/ok.svg";
import { ReactComponent as OMG } from "../../assets/svg/crypto/omg.svg";
import { ReactComponent as OMNI } from "../../assets/svg/crypto/omni.svg";
import { ReactComponent as ONE } from "../../assets/svg/crypto/one.svg";
import { ReactComponent as ONG } from "../../assets/svg/crypto/ong.svg";
import { ReactComponent as ONT } from "../../assets/svg/crypto/ont.svg";
import { ReactComponent as OOT } from "../../assets/svg/crypto/oot.svg";
import { ReactComponent as OST } from "../../assets/svg/crypto/ost.svg";
import { ReactComponent as OX } from "../../assets/svg/crypto/ox.svg";
import { ReactComponent as OXT } from "../../assets/svg/crypto/oxt.svg";
import { ReactComponent as OXY } from "../../assets/svg/crypto/oxy.svg";
import { ReactComponent as PART } from "../../assets/svg/crypto/part.svg";
import { ReactComponent as PASC } from "../../assets/svg/crypto/pasc.svg";
import { ReactComponent as PASL } from "../../assets/svg/crypto/pasl.svg";
import { ReactComponent as PAX } from "../../assets/svg/crypto/pax.svg";
import { ReactComponent as PAXG } from "../../assets/svg/crypto/paxg.svg";
import { ReactComponent as PAY } from "../../assets/svg/crypto/pay.svg";
import { ReactComponent as PAYX } from "../../assets/svg/crypto/payx.svg";
import { ReactComponent as PINK } from "../../assets/svg/crypto/pink.svg";
import { ReactComponent as PIRL } from "../../assets/svg/crypto/pirl.svg";
import { ReactComponent as PIVX } from "../../assets/svg/crypto/pivx.svg";
import { ReactComponent as PLR } from "../../assets/svg/crypto/plr.svg";
import { ReactComponent as POA } from "../../assets/svg/crypto/poa.svg";
import { ReactComponent as POE } from "../../assets/svg/crypto/poe.svg";
import { ReactComponent as POLIS } from "../../assets/svg/crypto/polis.svg";
import { ReactComponent as POLY } from "../../assets/svg/crypto/poly.svg";
import { ReactComponent as POT } from "../../assets/svg/crypto/pot.svg";
import { ReactComponent as POWR } from "../../assets/svg/crypto/powr.svg";
import { ReactComponent as PPC } from "../../assets/svg/crypto/ppc.svg";
import { ReactComponent as PPP } from "../../assets/svg/crypto/ppp.svg";
import { ReactComponent as PPT } from "../../assets/svg/crypto/ppt.svg";
import { ReactComponent as PRE } from "../../assets/svg/crypto/pre.svg";
import { ReactComponent as PRL } from "../../assets/svg/crypto/prl.svg";
import { ReactComponent as PUNGO } from "../../assets/svg/crypto/pungo.svg";
import { ReactComponent as PURA } from "../../assets/svg/crypto/pura.svg";
import { ReactComponent as QASH } from "../../assets/svg/crypto/qash.svg";
import { ReactComponent as QIWI } from "../../assets/svg/crypto/qiwi.svg";
import { ReactComponent as QLC } from "../../assets/svg/crypto/qlc.svg";
import { ReactComponent as QNT } from "../../assets/svg/crypto/qnt.svg";
import { ReactComponent as QRL } from "../../assets/svg/crypto/qrl.svg";
import { ReactComponent as QSP } from "../../assets/svg/crypto/qsp.svg";
import { ReactComponent as QTUM } from "../../assets/svg/crypto/qtum.svg";
import { ReactComponent as R } from "../../assets/svg/crypto/r.svg";
import { ReactComponent as RADS } from "../../assets/svg/crypto/rads.svg";
import { ReactComponent as RAP } from "../../assets/svg/crypto/rap.svg";
import { ReactComponent as RAY } from "../../assets/svg/crypto/ray.svg";
import { ReactComponent as RCN } from "../../assets/svg/crypto/rcn.svg";
import { ReactComponent as RDD } from "../../assets/svg/crypto/rdd.svg";
import { ReactComponent as RDN } from "../../assets/svg/crypto/rdn.svg";
import { ReactComponent as REN } from "../../assets/svg/crypto/ren.svg";
import { ReactComponent as REP } from "../../assets/svg/crypto/rep.svg";
import { ReactComponent as REPV2 } from "../../assets/svg/crypto/repv2.svg";
import { ReactComponent as REQ } from "../../assets/svg/crypto/req.svg";
import { ReactComponent as RHOC } from "../../assets/svg/crypto/rhoc.svg";
import { ReactComponent as RIC } from "../../assets/svg/crypto/ric.svg";
import { ReactComponent as RISE } from "../../assets/svg/crypto/rise.svg";
import { ReactComponent as RLC } from "../../assets/svg/crypto/rlc.svg";
import { ReactComponent as RPX } from "../../assets/svg/crypto/rpx.svg";
import { ReactComponent as RUB } from "../../assets/svg/crypto/rub.svg";
import { ReactComponent as RVN } from "../../assets/svg/crypto/rvn.svg";
import { ReactComponent as RYO } from "../../assets/svg/crypto/ryo.svg";
import { ReactComponent as SAFE } from "../../assets/svg/crypto/safe.svg";
import { ReactComponent as SAFEMOON } from "../../assets/svg/crypto/safemoon.svg";
import { ReactComponent as SAI } from "../../assets/svg/crypto/sai.svg";
import { ReactComponent as SALT } from "../../assets/svg/crypto/salt.svg";
import { ReactComponent as SAN } from "../../assets/svg/crypto/san.svg";
import { ReactComponent as SAND } from "../../assets/svg/crypto/sand.svg";
import { ReactComponent as SBD } from "../../assets/svg/crypto/sbd.svg";
import { ReactComponent as SBERBANK } from "../../assets/svg/crypto/sberbank.svg";
import { ReactComponent as SC } from "../../assets/svg/crypto/sc.svg";
import { ReactComponent as SER } from "../../assets/svg/crypto/ser.svg";
import { ReactComponent as SHIFT } from "../../assets/svg/crypto/shift.svg";
import { ReactComponent as SIB } from "../../assets/svg/crypto/sib.svg";
import { ReactComponent as SIN } from "../../assets/svg/crypto/sin.svg";
import { ReactComponent as SKL } from "../../assets/svg/crypto/skl.svg";
import { ReactComponent as SKY } from "../../assets/svg/crypto/sky.svg";
import { ReactComponent as SLR } from "../../assets/svg/crypto/slr.svg";
import { ReactComponent as SLS } from "../../assets/svg/crypto/sls.svg";
import { ReactComponent as SMART } from "../../assets/svg/crypto/smart.svg";
import { ReactComponent as SNGLS } from "../../assets/svg/crypto/sngls.svg";
import { ReactComponent as SNM } from "../../assets/svg/crypto/snm.svg";
import { ReactComponent as SNT } from "../../assets/svg/crypto/snt.svg";
import { ReactComponent as SNX } from "../../assets/svg/crypto/snx.svg";
import { ReactComponent as SOC } from "../../assets/svg/crypto/soc.svg";
import { ReactComponent as SOL } from "../../assets/svg/crypto/sol.svg";
import { ReactComponent as SPACEHBIT } from "../../assets/svg/crypto/spacehbit.svg";
import { ReactComponent as SPANK } from "../../assets/svg/crypto/spank.svg";
import { ReactComponent as SPHTX } from "../../assets/svg/crypto/sphtx.svg";
import { ReactComponent as SRN } from "../../assets/svg/crypto/srn.svg";
import { ReactComponent as STAK } from "../../assets/svg/crypto/stak.svg";
import { ReactComponent as START } from "../../assets/svg/crypto/start.svg";
import { ReactComponent as STEEM } from "../../assets/svg/crypto/steem.svg";
import { ReactComponent as STORJ } from "../../assets/svg/crypto/storj.svg";
import { ReactComponent as STORM } from "../../assets/svg/crypto/storm.svg";
import { ReactComponent as STOX } from "../../assets/svg/crypto/stox.svg";
import { ReactComponent as STQ } from "../../assets/svg/crypto/stq.svg";
import { ReactComponent as STRAT } from "../../assets/svg/crypto/strat.svg";
import { ReactComponent as STX } from "../../assets/svg/crypto/stx.svg";
import { ReactComponent as SUB } from "../../assets/svg/crypto/sub.svg";
import { ReactComponent as SUMO } from "../../assets/svg/crypto/sumo.svg";
import { ReactComponent as SUSHI } from "../../assets/svg/crypto/sushi.svg";
import { ReactComponent as SYS } from "../../assets/svg/crypto/sys.svg";
import { ReactComponent as TAAS } from "../../assets/svg/crypto/taas.svg";
import { ReactComponent as TAU } from "../../assets/svg/crypto/tau.svg";
import { ReactComponent as TBX } from "../../assets/svg/crypto/tbx.svg";
import { ReactComponent as TEL } from "../../assets/svg/crypto/tel.svg";
import { ReactComponent as TEN } from "../../assets/svg/crypto/ten.svg";
import { ReactComponent as TERN } from "../../assets/svg/crypto/tern.svg";
import { ReactComponent as TGCH } from "../../assets/svg/crypto/tgch.svg";
import { ReactComponent as THETA } from "../../assets/svg/crypto/theta.svg";
import { ReactComponent as TIX } from "../../assets/svg/crypto/tix.svg";
import { ReactComponent as TKN } from "../../assets/svg/crypto/tkn.svg";
import { ReactComponent as TKS } from "../../assets/svg/crypto/tks.svg";
import { ReactComponent as TNB } from "../../assets/svg/crypto/tnb.svg";
import { ReactComponent as TNC } from "../../assets/svg/crypto/tnc.svg";
import { ReactComponent as TNT } from "../../assets/svg/crypto/tnt.svg";
import { ReactComponent as TOMO } from "../../assets/svg/crypto/tomo.svg";
import { ReactComponent as TPAY } from "../../assets/svg/crypto/tpay.svg";
import { ReactComponent as TRIG } from "../../assets/svg/crypto/trig.svg";
import { ReactComponent as TRTL } from "../../assets/svg/crypto/trtl.svg";
import { ReactComponent as TRX } from "../../assets/svg/crypto/trx.svg";
import { ReactComponent as TUSD } from "../../assets/svg/crypto/tusd.svg";
import { ReactComponent as TZC } from "../../assets/svg/crypto/tzc.svg";
import { ReactComponent as UBQ } from "../../assets/svg/crypto/ubq.svg";
import { ReactComponent as UMA } from "../../assets/svg/crypto/uma.svg";
import { ReactComponent as UNI } from "../../assets/svg/crypto/uni.svg";
import { ReactComponent as UNITY } from "../../assets/svg/crypto/unity.svg";
import { ReactComponent as USD } from "../../assets/svg/crypto/usd.svg";
import { ReactComponent as UTK } from "../../assets/svg/crypto/utk.svg";
import { ReactComponent as VERI } from "../../assets/svg/crypto/veri.svg";
import { ReactComponent as VET } from "../../assets/svg/crypto/vet.svg";
import { ReactComponent as VIA } from "../../assets/svg/crypto/via.svg";
import { ReactComponent as VIB } from "../../assets/svg/crypto/vib.svg";
import { ReactComponent as VIBE } from "../../assets/svg/crypto/vibe.svg";
import { ReactComponent as VIVO } from "../../assets/svg/crypto/vivo.svg";
import { ReactComponent as VRC } from "../../assets/svg/crypto/vrc.svg";
import { ReactComponent as VRSC } from "../../assets/svg/crypto/vrsc.svg";
import { ReactComponent as VTC } from "../../assets/svg/crypto/vtc.svg";
import { ReactComponent as VTHO } from "../../assets/svg/crypto/vtho.svg";
import { ReactComponent as WABI } from "../../assets/svg/crypto/wabi.svg";
import { ReactComponent as WAN } from "../../assets/svg/crypto/wan.svg";
import { ReactComponent as WAVES } from "../../assets/svg/crypto/waves.svg";
import { ReactComponent as WAX } from "../../assets/svg/crypto/wax.svg";
import { ReactComponent as WBTC } from "../../assets/svg/crypto/wbtc.svg";
import { ReactComponent as WGR } from "../../assets/svg/crypto/wgr.svg";
import { ReactComponent as WICC } from "../../assets/svg/crypto/wicc.svg";
import { ReactComponent as WINGS } from "../../assets/svg/crypto/wings.svg";
import { ReactComponent as WPR } from "../../assets/svg/crypto/wpr.svg";
import { ReactComponent as WTC } from "../../assets/svg/crypto/wtc.svg";
import { ReactComponent as X } from "../../assets/svg/crypto/x.svg";
import { ReactComponent as XAS } from "../../assets/svg/crypto/xas.svg";
import { ReactComponent as XBC } from "../../assets/svg/crypto/xbc.svg";
import { ReactComponent as XBP } from "../../assets/svg/crypto/xbp.svg";
import { ReactComponent as XBY } from "../../assets/svg/crypto/xby.svg";
import { ReactComponent as XCP } from "../../assets/svg/crypto/xcp.svg";
import { ReactComponent as XDN } from "../../assets/svg/crypto/xdn.svg";
import { ReactComponent as XEM } from "../../assets/svg/crypto/xem.svg";
import { ReactComponent as XIN } from "../../assets/svg/crypto/xin.svg";
import { ReactComponent as XLM } from "../../assets/svg/crypto/xlm.svg";
import { ReactComponent as XMCC } from "../../assets/svg/crypto/xmcc.svg";
import { ReactComponent as XMG } from "../../assets/svg/crypto/xmg.svg";
import { ReactComponent as XMO } from "../../assets/svg/crypto/xmo.svg";
import { ReactComponent as XMY } from "../../assets/svg/crypto/xmy.svg";
import { ReactComponent as XP } from "../../assets/svg/crypto/xp.svg";
import { ReactComponent as XPA } from "../../assets/svg/crypto/xpa.svg";
import { ReactComponent as XPM } from "../../assets/svg/crypto/xpm.svg";
import { ReactComponent as XPR } from "../../assets/svg/crypto/xpr.svg";
import { ReactComponent as XSG } from "../../assets/svg/crypto/xsg.svg";
import { ReactComponent as XTZ } from "../../assets/svg/crypto/xtz.svg";
import { ReactComponent as XUC } from "../../assets/svg/crypto/xuc.svg";
import { ReactComponent as XVC } from "../../assets/svg/crypto/xvc.svg";
import { ReactComponent as XVG } from "../../assets/svg/crypto/xvg.svg";
import { ReactComponent as XZC } from "../../assets/svg/crypto/xzc.svg";
import { ReactComponent as YFI } from "../../assets/svg/crypto/yfi.svg";
import { ReactComponent as YOYOW } from "../../assets/svg/crypto/yoyow.svg";
import { ReactComponent as ZCL } from "../../assets/svg/crypto/zcl.svg";
import { ReactComponent as ZEC } from "../../assets/svg/crypto/zec.svg";
import { ReactComponent as ZEL } from "../../assets/svg/crypto/zel.svg";
import { ReactComponent as ZEN } from "../../assets/svg/crypto/zen.svg";
import { ReactComponent as ZEST } from "../../assets/svg/crypto/zest.svg";
import { ReactComponent as ZIL } from "../../assets/svg/crypto/zil.svg";
import { ReactComponent as ZILLA } from "../../assets/svg/crypto/zilla.svg";
import { ReactComponent as ZRX } from "../../assets/svg/crypto/zrx.svg";

import { ReactComponent as Sun } from "../../assets/svg/sun.svg";
import { ReactComponent as Half } from "../../assets/svg/half-2.svg";
import { ReactComponent as MoonStar } from "../../assets/svg/moon-star.svg";

import { ReactComponent as Globe } from "../../assets/svg/globe.svg";
import { ReactComponent as Question } from "../../assets/svg/question-mark-circled.svg";
import { ReactComponent as Wallet } from "../../assets/svg/wallet.svg";
import { ReactComponent as SortTimeAsc } from "../../assets/svg/sortTimeAsc.svg";
import { ReactComponent as SortTimeDesc } from "../../assets/svg/arrow-down-wide-narrow.svg";
import { ReactComponent as SortInvestmentAsc } from "../../assets/svg/investmentAsc.svg";
import { ReactComponent as SortInvestmentDesc } from "../../assets/svg/investmentDesc.svg";

interface IconComponentProps extends SvgIconProps {
  iconName: string;
  size?: number;
  customColor?: string;
  type?: "asBackground";
  style?: CSSProperties;
  hasFill?: boolean;
  hasStroke?: boolean;
}

const icons: { [key: string]: React.FunctionComponent<React.SVGProps<SVGSVGElement>> } = {
  blueDefault: blueDefault,
  primaryDefault: primaryDefault,
  greenDefault: greenDefault,
  pinkDefault: pinkDefault,
  lightBlueDefault: lightBlueDefault,
  "arrow-triangle": ArrowTriangleIcon,
  "caret-sort": CaretSort,
  "chevron-down": chevronDown,
  BTC: BTC,
  BTC_LIGHT: BTC_LIGHT,
  USDT_LIGHT: USDT_LIGHT,
  USDT: USDT,
  LTC: LTC,
  XRP: XRP,
  ETH: ETH,
  BCH: BCH,
  XMR: XMR,
  EOS: EOS,
  EUR: EUR,
  BINANCE: BINANCE,
  OKX: OKX,
  Auto: Auto,
  // "Line": Line,
  InfoIcon: InfoIcon,
  AlertIcon: AlertIcon,
  ErrorIcon: ErrorIcon,
  SuccessIcon: SuccessIcon,
  ChevronRight: ChevronRight,
  Sun: Sun,
  MoonStar: MoonStar,
  Half: Half,
  Wallet: Wallet,
  Question: Question,
  Globe: Globe,
  Plus: Plus,
  Coins: Coins,
  Clock: Clock,
  UK: UK,
  Russia: Russia,
  Copy: Copy,
  TradeUp: TradeUp,
  TradeDown: TradeDown,
  ChevronLeft: ChevronLeft,
  DotFilled: DotFilled,
  USDT_COLOR: USDT_COLOR,
  CHECK_CIRCLED: CHECK_CIRCLED,
  Settings: Settings,
  AEVO: AEVO,
  REYA_DEX: REYA,
  BYBIT: BYBIT,
  Check: Check,
  TradeCenter: TradeCenter,
  USDC: USDC,
  OutCheck: OutCheck,
  Checked: CheckedIcon,
  SortTimeAsc: SortTimeAsc,
  SortTimeDesc: SortTimeDesc,
  SortInvestmentAsc: SortInvestmentAsc,
  SortInvestmentDesc: SortInvestmentDesc,
  Avatar: Avatar,
  ErrorTriangle: ErrorTriangle,
  HPOS10I: HPOS10I,
  BELL: BELL,
  Search: Search,
  // '$PAC': $PAC,
  // '0XBTC': XBTC,
  // '1INCH': INCH,
  // '2GIVE': GIVE,
  AAVE: AAVE,
  ABT: ABT,
  ACT: ACT,
  ACTN: ACTN,
  ADA: ADA,
  ADD: ADD,
  ADX: ADX,
  AE: AE,
  AEON: AEON,
  AEUR: AEUR,
  AGI: AGI,
  AGRS: AGRS,
  AION: AION,
  ALGO: ALGO,
  AMB: AMB,
  AMP: AMP,
  AMPL: AMPL,
  ANKR: ANKR,
  ANT: ANT,
  APE: APE,
  APEX: APEX,
  APPC: APPC,
  ARDR: ARDR,
  ARG: ARG,
  ARK: ARK,
  ARN: ARN,
  ARNX: ARNX,
  ARY: ARY,
  AST: AST,
  ATLAS: ATLAS,
  ATM: ATM,
  ATOM: ATOM,
  AUDR: AUDR,
  AURY: AURY,
  AUTO: AUTO,
  AVAX: AVAX,
  AYWA: AYWA,
  BAB: BAB,
  BAL: BAL,
  BAND: BAND,
  BAT: BAT,
  BAY: BAY,
  BCBC: BCBC,
  BCC: BCC,
  BCD: BCD,
  BCIO: BCIO,
  BCN: BCN,
  BCO: BCO,
  BCPT: BCPT,
  BDL: BDL,
  BEAM: BEAM,
  BELA: BELA,
  BIX: BIX,
  BLCN: BLCN,
  BLK: BLK,
  BLOCK: BLOCK,
  BLZ: BLZ,
  BNB: BNB,
  BNT: BNT,
  BNTY: BNTY,
  BOOTY: BOOTY,
  BOS: BOS,
  BPT: BPT,
  BQ: BQ,
  BRD: BRD,
  BSD: BSD,
  BSV: BSV,
  BTCD: BTCD,
  BTCH: BTCH,
  BTCP: BTCP,
  BTCZ: BTCZ,
  BTDX: BTDX,
  BTG: BTG,
  BTM: BTM,
  BTS: BTS,
  BTT: BTT,
  BTX: BTX,
  BURST: BURST,
  BZE: BZE,
  CALL: CALL,
  CC: CC,
  CDN: CDN,
  CDT: CDT,
  CENZ: CENZ,
  CHAIN: CHAIN,
  CHAT: CHAT,
  CHIPS: CHIPS,
  CHSB: CHSB,
  CHZ: CHZ,
  CIX: CIX,
  CLAM: CLAM,
  CLOAK: CLOAK,
  CMM: CMM,
  CMT: CMT,
  CND: CND,
  CNX: CNX,
  CNY: CNY,
  COB: COB,
  COLX: COLX,
  COMP: COMP,
  COQUI: COQUI,
  CRED: CRED,
  CRPT: CRPT,
  CRV: CRV,
  CRW: CRW,
  CS: CS,
  CTR: CTR,
  CTXC: CTXC,
  CVC: CVC,
  D: D,
  DAI: DAI,
  DASH: DASH,
  DAT: DAT,
  DATA: DATA,
  DBC: DBC,
  DCN: DCN,
  DCR: DCR,
  DEEZ: DEEZ,
  DENT: DENT,
  DEW: DEW,
  DGB: DGB,
  DGD: DGD,
  DLT: DLT,
  DNT: DNT,
  DOCK: DOCK,
  DOGE: DOGE,
  DOT: DOT,
  DRGN: DRGN,
  DROP: DROP,
  DTA: DTA,
  DTH: DTH,
  DTR: DTR,
  EBST: EBST,
  ECA: ECA,
  EDG: EDG,
  EDO: EDO,
  EDOGE: EDOGE,
  ELA: ELA,
  ELEC: ELEC,
  ELF: ELF,
  ELIX: ELIX,
  ELLA: ELLA,
  EMB: EMB,
  EMC: EMC,
  EMC2: EMC2,
  ENG: ENG,
  ENJ: ENJ,
  ENTRP: ENTRP,
  EON: EON,
  EOP: EOP,
  EQLI: EQLI,
  EQUA: EQUA,
  ETC: ETC,
  ETHOS: ETHOS,
  ETN: ETN,
  ETP: ETP,
  EVX: EVX,
  EXMO: EXMO,
  EXP: EXP,
  FAIR: FAIR,
  FCT: FCT,
  FIDA: FIDA,
  FIL: FIL,
  FJC: FJC,
  FLDC: FLDC,
  FLO: FLO,
  FLUX: FLUX,
  FSN: FSN,
  FTC: FTC,
  FUEL: FUEL,
  FUN: FUN,
  GAME: GAME,
  GAS: GAS,
  GBP: GBP,
  GBX: GBX,
  GBYTE: GBYTE,
  GENERIC: GENERIC,
  GIN: GIN,
  GLXT: GLXT,
  GMR: GMR,
  GMT: GMT,
  GNO: GNO,
  GNT: GNT,
  GOLD: GOLD,
  GRC: GRC,
  GRIN: GRIN,
  GRS: GRS,
  GRT: GRT,
  GSC: GSC,
  GTO: GTO,
  GUP: GUP,
  GUSD: GUSD,
  GVT: GVT,
  GXS: GXS,
  GZR: GZR,
  HIGHT: HIGHT,
  HNS: HNS,
  HODL: HODL,
  HOT: HOT,
  HPB: HPB,
  HSR: HSR,
  HT: HT,
  HTML: HTML,
  HUC: HUC,
  HUSD: HUSD,
  HUSH: HUSH,
  ICN: ICN,
  ICP: ICP,
  ICX: ICX,
  IGNIS: IGNIS,
  ILK: ILK,
  INK: INK,
  INS: INS,
  ION: ION,
  IOP: IOP,
  IOST: IOST,
  IOTX: IOTX,
  IQ: IQ,
  ITC: ITC,
  JNT: JNT,
  JPY: JPY,
  KCS: KCS,
  KIN: KIN,
  KLOWN: KLOWN,
  KMD: KMD,
  KNC: KNC,
  KRB: KRB,
  KSM: KSM,
  LBC: LBC,
  LEND: LEND,
  LEO: LEO,
  LINK: LINK,
  LKK: LKK,
  LOOM: LOOM,
  LPT: LPT,
  LRC: LRC,
  LSK: LSK,
  LUN: LUN,
  MAID: MAID,
  MANA: MANA,
  MATIC: MATIC,
  MAX: MAX,
  MCAP: MCAP,
  MCO: MCO,
  MDA: MDA,
  MDS: MDS,
  MED: MED,
  MEETONE: MEETONE,
  MFT: MFT,
  MIOTA: MIOTA,
  MITH: MITH,
  MKR: MKR,
  MLN: MLN,
  MNX: MNX,
  MNZ: MNZ,
  MOAC: MOAC,
  MOD: MOD,
  MONA: MONA,
  MSR: MSR,
  MTH: MTH,
  MTL: MTL,
  MUSIC: MUSIC,
  MZC: MZC,
  NANO: NANO,
  NAS: NAS,
  NAV: NAV,
  NCASH: NCASH,
  NDZ: NDZ,
  NEBL: NEBL,
  NEO: NEO,
  NEOS: NEOS,
  NEU: NEU,
  NEXO: NEXO,
  NGC: NGC,
  NIO: NIO,
  NKN: NKN,
  NLC2: NLC2,
  NLG: NLG,
  NMC: NMC,
  NMR: NMR,
  NPXS: NPXS,
  NTBC: NTBC,
  NULS: NULS,
  NXS: NXS,
  NXT: NXT,
  OAX: OAX,
  OK: OK,
  OMG: OMG,
  OMNI: OMNI,
  ONE: ONE,
  ONG: ONG,
  ONT: ONT,
  OOT: OOT,
  OST: OST,
  OX: OX,
  OXT: OXT,
  OXY: OXY,
  PART: PART,
  PASC: PASC,
  PASL: PASL,
  PAX: PAX,
  PAXG: PAXG,
  PAY: PAY,
  PAYX: PAYX,
  PINK: PINK,
  PIRL: PIRL,
  PIVX: PIVX,
  PLR: PLR,
  POA: POA,
  POE: POE,
  POLIS: POLIS,
  POLY: POLY,
  POT: POT,
  POWR: POWR,
  PPC: PPC,
  PPP: PPP,
  PPT: PPT,
  PRE: PRE,
  PRL: PRL,
  PUNGO: PUNGO,
  PURA: PURA,
  QASH: QASH,
  QIWI: QIWI,
  QLC: QLC,
  QNT: QNT,
  QRL: QRL,
  QSP: QSP,
  QTUM: QTUM,
  R: R,
  RADS: RADS,
  RAP: RAP,
  RAY: RAY,
  RCN: RCN,
  RDD: RDD,
  RDN: RDN,
  REN: REN,
  REP: REP,
  REPV2: REPV2,
  REQ: REQ,
  RHOC: RHOC,
  RIC: RIC,
  RISE: RISE,
  RLC: RLC,
  RPX: RPX,
  RUB: RUB,
  RVN: RVN,
  RYO: RYO,
  SAFE: SAFE,
  SAFEMOON: SAFEMOON,
  SAI: SAI,
  SALT: SALT,
  SAN: SAN,
  SAND: SAND,
  SBD: SBD,
  SBERBANK: SBERBANK,
  SC: SC,
  SER: SER,
  SHIFT: SHIFT,
  SIB: SIB,
  SIN: SIN,
  SKL: SKL,
  SKY: SKY,
  SLR: SLR,
  SLS: SLS,
  SMART: SMART,
  SNGLS: SNGLS,
  SNM: SNM,
  SNT: SNT,
  SNX: SNX,
  SOC: SOC,
  SOL: SOL,
  SPACEHBIT: SPACEHBIT,
  SPANK: SPANK,
  SPHTX: SPHTX,
  SRN: SRN,
  STAK: STAK,
  START: START,
  STEEM: STEEM,
  STORJ: STORJ,
  STORM: STORM,
  STOX: STOX,
  STQ: STQ,
  STRAT: STRAT,
  STX: STX,
  SUB: SUB,
  SUMO: SUMO,
  SUSHI: SUSHI,
  SYS: SYS,
  TAAS: TAAS,
  TAU: TAU,
  TBX: TBX,
  TEL: TEL,
  TEN: TEN,
  TERN: TERN,
  TGCH: TGCH,
  THETA: THETA,
  TIX: TIX,
  TKN: TKN,
  TKS: TKS,
  TNB: TNB,
  TNC: TNC,
  TNT: TNT,
  TOMO: TOMO,
  TPAY: TPAY,
  TRIG: TRIG,
  TRTL: TRTL,
  TRX: TRX,
  TUSD: TUSD,
  TZC: TZC,
  UBQ: UBQ,
  UMA: UMA,
  UNI: UNI,
  UNITY: UNITY,
  USD: USD,
  UTK: UTK,
  VERI: VERI,
  VET: VET,
  VIA: VIA,
  VIB: VIB,
  VIBE: VIBE,
  VIVO: VIVO,
  VRC: VRC,
  VRSC: VRSC,
  VTC: VTC,
  VTHO: VTHO,
  WABI: WABI,
  WAN: WAN,
  WAVES: WAVES,
  WAX: WAX,
  WBTC: WBTC,
  WGR: WGR,
  WICC: WICC,
  WINGS: WINGS,
  WPR: WPR,
  WTC: WTC,
  X: X,
  XAS: XAS,
  XBC: XBC,
  XBP: XBP,
  XBY: XBY,
  XCP: XCP,
  XDN: XDN,
  XEM: XEM,
  XIN: XIN,
  XLM: XLM,
  XMCC: XMCC,
  XMG: XMG,
  XMO: XMO,
  XMY: XMY,
  XP: XP,
  XPA: XPA,
  XPM: XPM,
  XPR: XPR,
  XSG: XSG,
  XTZ: XTZ,
  XUC: XUC,
  XVC: XVC,
  XVG: XVG,
  XZC: XZC,
  YFI: YFI,
  YOYOW: YOYOW,
  ZCL: ZCL,
  ZEC: ZEC,
  ZEL: ZEL,
  ZEN: ZEN,
  ZEST: ZEST,
  ZIL: ZIL,
  ZILLA: ZILLA,
  ZRX: ZRX,
  TRUMP: TRUMP,
  PlusQuare: PlusQuare,
  MinusQuare: MinusQuare,
  RadioChecked: RadioChecked,
  RadioUnchecked: RadioUnchecked,
};

const getSVGDataURL = (SvgComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>) => {
  const svgString = renderToString(<SvgComponent />);
  return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
};

const getRandomDefaultIcon = () => {
  const colors = [
    "blueDefault",
    "greenDefault",
    "pinkDefault",
    "primaryDefault",
    "lightBlueDefault",
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

const IconComponent: React.FC<IconComponentProps> = ({
  iconName,
  size,
  customColor,
  type,
  style,
  hasFill,
  hasStroke,
  ...props
}) => {
  const theme = useTheme();
  const Icon = icons[iconName] ? icons[iconName] : icons[getRandomDefaultIcon()];

  const computedColor = customColor ? customColor : theme.palette.text.secondary;

  if (type === "asBackground") {
    const backgroundImageUrl = getSVGDataURL(Icon);
    return (
      <div style={style}>
        <div
          style={{
            width: size ? size : 19,
            height: size ? size : 19,
            backgroundImage: `url(${backgroundImageUrl})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
          }}
        />
      </div>
    );
  }

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Icon
        {...props}
        width={size ? size : 19}
        height={size ? size : 19}
        fill={!hasFill ? computedColor : "none"}
        stroke={!!hasStroke ? computedColor : "none"}
      />
    </Stack>
  );
};

export default IconComponent;
